import React from 'react';
import { connect } from 'react-redux';
import { Textfit } from 'react-textfit';

const TorsoTextOverlay = ({
    torsoText,
    minFontSize = 15,
    showBackImage,
    torsoTextState,
    selectedProducts,
    currentlySelectedAttributes,
    currentPageView,
    productTags,
    product,
}) => {
    const firstVariant = product?.variants?.nodes[0];
    const textToShow = torsoTextState ? torsoTextState : torsoText;
    const torsoAttributes = selectedProducts?.bodies?.attributes;

    let torsoColor = '';
    if (currentlySelectedAttributes && currentPageView === 'bodies') {
        torsoColor = currentlySelectedAttributes?.title?.toLowerCase();
    } else if (!currentlySelectedAttributes && torsoAttributes && torsoAttributes !== undefined) {
        torsoColor = torsoAttributes?.title?.toLowerCase();
    } else {
        torsoColor = firstVariant?.title?.toLowerCase();
    }

    if ((productTags && productTags.includes('disable text overlay')) || !torsoColor) {
        return <></>;
    }

    let colorClass = '';
    const torsoOverlayColorClass = () => {
        switch (torsoColor) {
            case 'green':
            case 'blue':
            case 'dark grey':
            case 'purole':
            case 'red':
            case 'dark red':
            case 'brown':
            case 'dark green':
            case 'navy':
            case 'black':
            case 'dark tan':
            case 'khaki':
            case 'sand green':
                colorClass = 'torso-text-overlay--white';
                break;
            case 'light grey':
            case 'blue grey':
            case 'white':
            case 'light blue':
            case 'bright light blue':
            case 'turquoise':
            case 'lime green':
            case 'bright light green':
            case 'yellow':
            case 'pale pink':
            case 'light tan':
            case 'pink':
            case 'orange':
                colorClass = 'torso-text-overlay--black';
                break;
            default:
        }

        return colorClass;
    };

    return (
        <div className={`torso-text-overlay ${torsoOverlayColorClass()}`}>
            <div className={`text ${showBackImage ? 'back-text' : 'front-text'}`}>
                <Textfit
                    mode="multi"
                    forceSingleModeWidth={false}
                    max={500}
                    min={minFontSize}
                    style={{ height: '100%' }}
                >
                    {showBackImage ? textToShow.backText : textToShow.frontText}
                </Textfit>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        torsoText: state.builds[state.currentBuildIndex].torsoText,
        selectedProducts: state.builds[state.currentBuildIndex].selected,
        currentPageView: state.navigation.selected,
    };
};

export default connect(mapStateToProps)(TorsoTextOverlay);
